import {theme} from 'antd';
import React from 'react';

interface Props {
  data: any;
  buttonJSX?: JSX.Element;
  sentToAddressMarkUp?: JSX.Element;
}

const RedeemAdditionaDataRow = (props: Props) => {
  const {token}: any = theme.useToken();
  const cellStyle: React.CSSProperties = {border: `1px solid ${token.colorSecondary}`, padding: 8};

  return (
    <table aria-label="history" style={{width: '100%', borderCollapse: 'collapse'}}>
      <thead>
        <tr>
          <th style={{...cellStyle, width: 160, textAlign: 'left'}}>Sent to</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{...cellStyle, lineHeight: '12px'}}>
            <span
              style={{
                textOverflow: 'word-wrap',
                overflowWrap: 'break-word',
                lineHeight: '12px',
              }}>
              {props.data.sentToEmail}
            </span>
            {props.sentToAddressMarkUp}
          </td>
          <td style={cellStyle} />
          <td style={cellStyle} />
          <td style={cellStyle} />
          <td style={cellStyle} />
          <td style={cellStyle} />
          <td style={{...cellStyle, textAlign: 'right'}} colSpan={5}>
            {props.buttonJSX}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RedeemAdditionaDataRow;
